class VgDisclosureGroup extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        this.name = this.getAttribute('name');
        this.multiple = this.getAttribute('multiple') === 'false' ? false : true;
    }
}

class VgDisclosure extends HTMLElement {

    static generateId() {
        return Date.now().toString(36) + Math.random().toString(36).substring(2);
    }

    constructor() {
        super();
    }

    connectedCallback() {
        this.media = this.getAttribute('media');
        this.headingSelector = this.getAttribute('heading-selector') ?? 'h2';
        this.panelSelector = this.getAttribute('panel-selector');
        this.groupName = this.getAttribute('group-name');
        this.heading = this.querySelector(this.headingSelector);
        this.panel = this.panelSelector ? this.querySelector(this.panelSelector) : this.heading.nextElementSibling;

        if (this.media) {
            const mediaQuery = window.matchMedia(this.media);
            mediaQuery.addListener(this.handleMediaChange.bind(this));
            if (mediaQuery.matches) {
                this.mount();
            }
        } else {
            this.mount();
        }
    }

    mount() {
        let id = this.panel.getAttribute('id');
        if (!id) {
            id = this.constructor.generateId();
            this.panel.setAttribute('id', id);
        }
        // Wrap the heading text content in a button.
        const originalText = this.heading.textContent.trim();

        this.button = document.createElement('button');

        if (this.hasAttribute('with-arrow')) {
            this.button.classList.add('disclosure-has-arrow');
            this.button.innerHTML = `
              ${originalText}
              <span class="arrow"></span>
            `;
        } else {
            this.button.textContent = originalText;
        }
        this.button.addEventListener('click', this);
        this.button.setAttribute('aria-expanded', 'false');
        this.button.setAttribute('aria-controls', id);
        this.heading.textContent = '';
        this.heading.appendChild(this.button);
        this.panel.setAttribute('hidden', 'hidden');
    }

    unmount() {
        this.heading.textContent = this.button.textContent;
        this.panel.removeAttribute('hidden');
    }

    handleEvent(e) {
        if ('click' === e.type) {
            this.toggle();
            e.preventDefault();
            return;
        }
    }

    toggle() {
        const group = document.querySelector(`vg-disclosure-group[name="${this.groupName}"]`);
        if (this.isOpen()) {
            this.close();
        } else {
            if (group?.multiple === false) {
                let col = document.querySelectorAll(`vg-disclosure[group-name="${this.groupName}"]`);
                col.forEach((el) => {
                    if (el !== this) {
                        try {
                            el.close();
                        } catch {
                            // Ignore error trying to close uninitialised disclosure.
                        }
                    }
                });
            }
            this.open();
        }
    }

    isOpen() {
        return this.button.getAttribute('aria-expanded') === 'true';
    }

    close() {

        this.button.setAttribute('aria-expanded', 'false');
        this.panel.setAttribute('hidden', '');
        this.removeAttribute('data-open');
        if (this.hasAttribute('with-arrow')) {
            this.panel.style.height = `${this.panel.scrollHeight}px`;

            requestAnimationFrame(() => {
                this.panel.style.transition = 'height 0.3s ease-out';
                this.panel.style.height = '0px';
            });

            this.panel.addEventListener('transitionend', () => {
                if (!this.isOpen()) {
                    this.panel.style.display = 'none';
                    this.panel.setAttribute('hidden', '');
                }
            }, { once: true });

        }
    }

    open() {
        this.button.setAttribute('aria-expanded', 'true');
        this.panel.removeAttribute('hidden');
        this.setAttribute('data-open', 'true');
        if (this.hasAttribute('with-arrow')) {
            this.panel.style.display = 'block';

            // Poner altura en 0 para arrancar "desde cerrado"
            this.panel.style.height = '0px';
            this.panel.style.overflow = 'hidden';        // normalmente se usa overflow:hidden
            this.panel.style.transition = 'none';        // quitamos transición temporalmente
            // Forzamos el reflow para que el navegador aplique "height=0"
            this.panel.offsetHeight; // ¡importante!

            // Calculamos la altura real
            const finalHeight = this.panel.scrollHeight + 'px';

            // Ahora sí hacemos la animación
            requestAnimationFrame(() => {
                this.panel.style.transition = 'height 0.3s ease-out';
                this.panel.style.height = finalHeight;
            });

            // Cuando acaba la transición, ponemos height auto (si queremos)
            this.panel.addEventListener('transitionend', () => {
                if (this.isOpen()) {
                    this.panel.style.height = 'auto';
                    this.panel.style.overflow = '';
                }
            }, { once: true });

        }

    }

    handleMediaChange(e) {
        e.matches ? this.mount() : this.unmount();
    }
}

customElements.define('vg-disclosure', VgDisclosure);
customElements.define('vg-disclosure-group', VgDisclosureGroup);
